module.exports = __webpack_public_path__ + "static/media/AeroFarmInactive.cad29968.png";